import React from 'react';

export default function Footer() {
  return (
    <footer>
      <div className="container-x foot-row">
        <span>© 2026 — Raphaël Bertaina-Loichemol</span>
        <span><a href="#top">Back to top ↑</a></span>
      </div>
    </footer>
  );
}
